import { KeyRound, Link as LinkIcon, Mail } from 'lucide-react';
import { type CustomAction } from '@bliks-io/ui';
import { type TenantUserAdminListItem } from '@bliks-io/contracts';

/**
 * Helper function to get status-based custom actions for tenant users
 */
export function getTenantUserStatusActions(
  user: TenantUserAdminListItem,
  handlers: {
    onSendInvitation: (userId: string) => void;
    onCopyActivationLink: (userId: string) => void;
    onResetSignIn: (user: TenantUserAdminListItem) => void;
  },
  t: (key: string) => string
) {
  const actions: CustomAction[] = [];

  if (user.status === 'inactive') {
    actions.push({
      label: t('adminSettings.tenant.sendInvitationAction'),
      icon: <Mail className="w-4 h-4" />,
      onClick: () => handlers.onSendInvitation(user._id)
    });
  } else if (user.status === 'pending') {
    actions.push({
      label: t('adminSettings.tenant.resendInvitationAction'),
      icon: <Mail className="w-4 h-4" />,
      onClick: () => handlers.onSendInvitation(user._id)
    });
  }

  // Whether a link can exist at all is the backend's call (lifecycle status
  // plus credential state) — see TenantUserAdminListItemSchema.
  if (user.activationLinkAvailable) {
    actions.push({
      label: t('adminSettings.tenant.copyActivationLinkAction'),
      icon: <LinkIcon className="w-4 h-4" />,
      onClick: () => handlers.onCopyActivationLink(user._id)
    });
  }

  if (user.signInResetAvailable) {
    actions.push({
      label: t('organization.members.resetSignInAction'),
      icon: <KeyRound className="w-4 h-4" />,
      onClick: () => handlers.onResetSignIn(user),
      variant: 'destructive'
    });
  }

  return actions;
}
